import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-salvarfiltro',
    templateUrl: './salvarfiltro.component.html',
    styleUrls: ['./salvarfiltro.component.css'],
    standalone: false
})
export class SalvarfiltroComponent implements OnInit {

  value = '';

  fillControl = new UntypedFormControl('', [
    Validators.required
  ]);
  
  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>) { }

  ngOnInit() {
    if ( this.data != null && this.data.name ){
      this.fillControl.setValue(this.data.name);
    }
  }

  closeDialog(){
    this.dialogRef.close(false);
  }

  salvar(){
    if (!this.fillControl.valid) {
      this.fillControl.markAsTouched();
      return;
    }else{
      // o antigo template misturava [(ngModel)] com [formControl]; agora o nome vem do control
      this.data.name = this.fillControl.value;
      this.dialogRef.close(this.data);
    }
  }
}
